import React, { PropsWithChildren } from "react";

import {
  AllRepeatOptions,
  CalendarYearEndField,
  CalendarYearStartField,
  EndsField,
  NoneRepeatOption,
  RepeatOptionsNotNone,
  RepeatsField,
  SpousesAgeEndField,
  SpousesAgeStartField,
  StartsField,
  TargetDateField,
  YourAgeEndField,
  YourAgeStartField,
} from "../../constants";
import MultiDropdownInput from "../MultiDropdownInput";
import PlanDateMultiDropdownInput from "../PlanDateMultiDropdownInput/PlanDateMultiDropdownInput";
import FormDateField, {
  DateStringInputFormat,
} from "@src/sharedComponents/Forms/FormDateField";

interface Props {
  repeatsFieldLabel?: string;
  curRepeatsOption: string;
  repeatsInputFieldLabel?: string;
  repeatsInputFormat?: DateStringInputFormat;
  repeatsInputPlaceholder?: string;
  repeatsInputRequired?: string;
  isDisabled?: boolean;
  isHidden?: boolean;
  readOnly?: boolean;
  hideSpouseOptions?: boolean;

  curPlanDateStartOption: string;
  planDateStartFieldLabel?: string;
  planDateStartInput1FieldLabel?: string;
  planDateStartInput2FieldLabel?: string;
  planDateStartInput3FieldLabel?: string;

  curPlanDateEndOption: string;
  planDateEndFieldLabel?: string;
  planDateEndInput1FieldLabel?: string;
  planDateEndInput2FieldLabel?: string;
  planDateEndInput3FieldLabel?: string;
}

const RepeatsMultiDropdownInput = ({
  repeatsFieldLabel = "Repeats",
  curRepeatsOption,
  repeatsInputFieldLabel = "Target Date",
  repeatsInputFormat = "MM/yyyy",
  repeatsInputPlaceholder = "MM/YYYY",
  repeatsInputRequired = "Must not be empty",
  isDisabled,
  isHidden,
  readOnly,
  hideSpouseOptions,

  curPlanDateStartOption,
  planDateStartFieldLabel = "Starts",
  planDateStartInput1FieldLabel = "Calendar Year",
  planDateStartInput2FieldLabel = "Your Age",
  planDateStartInput3FieldLabel = "Spouse's Age",

  curPlanDateEndOption,
  planDateEndFieldLabel = "Ends",
  planDateEndInput1FieldLabel = "Calendar Year",
  planDateEndInput2FieldLabel = "Your Age",
  planDateEndInput3FieldLabel = "Spouse's Age",

  children,
}: PropsWithChildren<Props>) => {
  return (
    <MultiDropdownInput
      fieldName={RepeatsField}
      fieldLabel={repeatsFieldLabel}
      curOption={curRepeatsOption}
      options={AllRepeatOptions}
      isHidden={isHidden}
      isDisabled={isDisabled}
      readOnly={readOnly}
      displayInput1OnOptions={NoneRepeatOption}
      additionalInput1={
        <FormDateField
          name={TargetDateField}
          label={repeatsInputFieldLabel}
          inputFormat={repeatsInputFormat}
          placeholder={repeatsInputPlaceholder}
          required={repeatsInputRequired}
          disabled={isDisabled}
          readonly={readOnly}
        />
      }
      fillUpSpaceIfNotRenderedInput1={true}
      displayInput2OnOptions={RepeatOptionsNotNone}
      additionalInput2={
        <PlanDateMultiDropdownInput
          isDisabled={isDisabled}
          curPlanDateOption={curPlanDateStartOption}
          planDateFieldName={StartsField}
          planDateFieldLabel={planDateStartFieldLabel}
          isEndDate={false}
          input1FieldName={CalendarYearStartField}
          input1FieldLabel={planDateStartInput1FieldLabel}
          input2FieldName={YourAgeStartField}
          input2FieldLabel={planDateStartInput2FieldLabel}
          input3FieldName={SpousesAgeStartField}
          input3FieldLabel={planDateStartInput3FieldLabel}
          hideSpouseOptions={hideSpouseOptions}
        />
      }
      displayInput3OnOptions={RepeatOptionsNotNone}
      additionalInput3={
        <PlanDateMultiDropdownInput
          isDisabled={isDisabled}
          curPlanDateOption={curPlanDateEndOption}
          planDateFieldName={EndsField}
          planDateFieldLabel={planDateEndFieldLabel}
          isEndDate={true}
          input1FieldName={CalendarYearEndField}
          input1FieldLabel={planDateEndInput1FieldLabel}
          input2FieldName={YourAgeEndField}
          input2FieldLabel={planDateEndInput2FieldLabel}
          input3FieldName={SpousesAgeEndField}
          input3FieldLabel={planDateEndInput3FieldLabel}
          hideSpouseOptions={hideSpouseOptions}
        />
      }
    >
      {children}
    </MultiDropdownInput>
  );
};

export default RepeatsMultiDropdownInput;
